import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const searchCity = async (searchTerm: string) => {
  return await get<ApiResponse<any[]>>(`/region?search=${encodeURIComponent(searchTerm)}&limit=50`).then((res) => res);
};